import { render, staticRenderFns } from "./tklRecord.vue?vue&type=template&id=4ea057bc&scoped=true&"
import script from "./tklRecord.vue?vue&type=script&lang=js&"
export * from "./tklRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea057bc",
  null
  
)

export default component.exports